module.exports = __webpack_public_path__ + "static/atl-4289e162fb074f43cd5bb55cc922371d.png";